// extracted by mini-css-extract-plugin
module.exports = {"statusLabel":"Status_statusLabel__Pi1Uz"};